"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Fade = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Transition = _interopRequireWildcard(require("react-transition-group/Transition"));
var _Modal = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal.css") : void 0);
const _excluded = ["children"],
  _excluded2 = ["className", "isModal", "appear", "mountOnEnter", "timeout", "unmountOnExit"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const CSS_BLOCK = 'sapcnqr-modal';
const Fade = _ref => {
  let {
      children
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
      className,
      isModal,
      appear = false,
      mountOnEnter = false,
      timeout = 300,
      unmountOnExit = true
    } = props,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded2);
  const classnames = _bind.default.bind(_Modal.default);
  const fadeStyles = {
    [_Transition.ENTERING]: `${CSS_BLOCK}__fade--in`,
    [_Transition.ENTERED]: `${CSS_BLOCK}__fade--in`
  };
  return /*#__PURE__*/_react.default.createElement(_Transition.default, (0, _extends2.default)({}, otherProps, {
    appear: appear,
    timeout: timeout,
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit
  }), (status, innerProps) => /*#__PURE__*/_react.default.cloneElement(children, _objectSpread(_objectSpread({}, innerProps), {}, {
    className: classnames(className, children.props.className, `${CSS_BLOCK}__fade`, fadeStyles[status], {
      [`${CSS_BLOCK}__fade--non-modal`]: !isModal
    })
  })));
};
exports.Fade = Fade;
Fade.displayName = 'Fade';
Fade.propTypes = {
  appear: _propTypes.default.bool,
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  in: _propTypes.default.bool,
  isModal: _propTypes.default.bool,
  mountOnEnter: _propTypes.default.bool,
  timeout: _propTypes.default.number,
  unmountOnExit: _propTypes.default.bool
};
var _default = exports.default = Fade;